"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8945],{

/***/ 58945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ addToCart; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (react.isValidElement(oldChildren) && react.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(Transition/* ENTERING */.d0, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(Transition/* ENTERING */.d0);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(Transition/* ENTERED */.cn, react.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(Transition/* ENTERED */.cn, react.cloneElement(children, {
        in: true
      }));
    })
  }), react.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: Transition/* ENTERED */.cn,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === Transition/* ENTERING */.d0 && props.mode === modes.in) {
      return {
        status: Transition/* ENTERING */.d0
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: Transition/* EXITING */.Ix
      };
    }

    return {
      current: react.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case Transition/* ENTERING */.d0:
        component = enterRenders[mode](data);
        break;

      case Transition/* EXITING */.Ix:
        component = leaveRenders[mode](data);
        break;

      case Transition/* ENTERED */.cn:
        component = current;
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(react.Component);

SwitchTransition.propTypes =  false ? 0 : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ var esm_SwitchTransition = (SwitchTransition);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/addToCart/AddToCart.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var AddToCart = function AddToCart(_ref) {
  var productId = _ref.productId,
      _onSuccess = _ref.onSuccess,
      _ref$isProductConfig = _ref.isProductConfig,
      isProductConfig = _ref$isProductConfig === void 0 ? false : _ref$isProductConfig,
      _ref$isWishlist = _ref.isWishlist,
      isWishlist = _ref$isWishlist === void 0 ? false : _ref$isWishlist,
      inStock = _ref.inStock,
      buttonProps = _ref.buttonProps,
      _ref$productInfo = _ref.productInfo,
      productInfo = _ref$productInfo === void 0 ? {} : _ref$productInfo,
      _ref$currentSize = _ref.currentSize,
      currentSize = _ref$currentSize === void 0 ? null : _ref$currentSize,
      _ref$setIsOpenSize = _ref.setIsOpenSize,
      setIsOpenSize = _ref$setIsOpenSize === void 0 ? null : _ref$setIsOpenSize,
      _ref$ids = _ref.ids,
      configIds = _ref$ids === void 0 ? null : _ref$ids;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useSelector = (0,es/* useSelector */.v9)(store/* cartInfoSelector */.wg),
      ids = _useSelector.ids,
      count = _useSelector.count;

  var productInCart = (configIds || ids).some(function (id) {
    return id == productId;
  });

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'cart'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      cartHref = _getLinkProps2[0],
      cartAs = _getLinkProps2[1];

  var isOutOfStock = (0,react.useMemo)(function () {
    if (currentSize === true || !(currentSize !== null && currentSize !== void 0 && currentSize.value)) {
      return inStock === false;
    }

    return !currentSize.has;
  }, [inStock, currentSize]);
  var addToCart = (0,react.useCallback)(function () {
    var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');

    var putIntoCart = function putIntoCart() {
      dispatch((0,cartSlice/* updateCartIds */.U9)({
        ids: [].concat((0,toConsumableArray/* default */.Z)(ids), [productId])
      }));
      dispatch((0,cartSlice/* updateCartCount */.N1)({
        count: count + 1
      }));
      dispatch((0,cartSlice/* createInCart */.p$)({
        mindboxDeviceUUID: mindboxDeviceUUID || '',
        id: productId,
        meta: productInfo,
        quantity: 1,
        onSuccess: function onSuccess() {
          if (window && window.generalPixel) {
            window.generalPixel.postClick('a1');
          }

          _onSuccess();
        },
        onError: function onError() {
          dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
            forceRefresh: true
          }));
        }
      }));
    };

    if (isProductConfig || isWishlist) {
      if (currentSize) {
        putIntoCart();
      } else {
        setIsOpenSize(true);
      }
    } else {
      putIntoCart();
    }
  }, [productId, _onSuccess, dispatch, ids, count, productInfo, isProductConfig, currentSize, setIsOpenSize]);

  var renderButton = function renderButton() {
    if (isOutOfStock) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, _objectSpread(_objectSpread({}, buttonProps), {}, {
        disabled: true,
        type: "primary",
        children: "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438"
      }));
    }

    if (productInCart) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: cartHref,
        as: cartAs,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, _objectSpread(_objectSpread({}, buttonProps), {}, {
          children: "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0435"
        }))
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, _objectSpread(_objectSpread({}, buttonProps), {}, {
      onClick: addToCart,
      type: "primary",
      children: "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0443"
    }));
  };

  var buttonKey = 'В корзину';

  if (isOutOfStock) {
    buttonKey = 'Нет в наличии';
  } else if (productInCart) {
    buttonKey = 'Перейти в корзину';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SwitchTransition, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
      timeout: {
        appear: 0,
        enter: 0,
        exit: 200
      },
      classNames: "on",
      children: renderButton()
    }, buttonKey)
  });
};

/* harmony default export */ var addToCart_AddToCart = (AddToCart);
;// CONCATENATED MODULE: ./components/addToCart/index.js

/* harmony default export */ var addToCart = (addToCart_AddToCart);

/***/ })

}]);